import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { track, flushOnHide } from "@/lib/track";
import { TopBar } from "./TopBar";
import { Footer } from "./Footer";

export function Layout() {
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  const enterTime = useRef<number>(Date.now());
  const prevPath = useRef<string>(pathname);

  // 注册页面卸载监听，确保缓冲区数据不丢
  useEffect(() => flushOnHide(), []);

  useEffect(() => {
    // 离开上一页 -> page_leave（带停留时长）
    const duration = Date.now() - enterTime.current;
    track("page_leave", "page", {
      page: prevPath.current,
      duration,
    });

    // 进入新页 -> page_view
    track("page_view", "page", { page: pathname });

    enterTime.current = Date.now();
    prevPath.current = pathname;
    mainRef.current?.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <TopBar />
      <main
        ref={mainRef}
        className="flex-1 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        <Outlet />
        <Footer />
      </main>
    </div>
  );
}
